import { makeAutoObservable } from "mobx";
import { IRootStore } from "./RootStore";

export class CallingStore {
  show = false;
  emergencyId: string = "";
  flightId: string = "";
  crewname: string = "";
  endVoiceCall: number = 0;
  childWindowReference = null;
  inComingCall: boolean = false;
  pauseDecline: boolean = false; // New property to manage pauseDecline state
  rootStore: IRootStore;

  constructor(rootStore: IRootStore) {
    makeAutoObservable(this);

    this.rootStore = rootStore;
  }

  showNotification(
  ) {
    this.show = true;
  }

  resetNotification() {
    this.show = false;
  }

  handleShow = (a: boolean) => {
    this.show = a;
  };

  get getShow() {
    return this.show;
  }

  handleEmergencyId = (id: string) => {
    this.emergencyId = id;
  }
  get EmergencyId() {
    return this.emergencyId;
  }

  handleFlightId = (id: string) => {
    this.flightId = id;
  }
  get FlightId() {
    return this.flightId;
  }

  handleEndVoiceCall = () => {
    this.endVoiceCall++;
  }
  get getEndVoiceCall() {
    return this.endVoiceCall;
  }
  resetEndVoiceCall = () => {
    this.endVoiceCall = 0;
  }

  handleChildWindowRef = (winRef: any) => {
    this.childWindowReference = winRef
  }
  get getChildWindowRef() {
    return this.childWindowReference;
  }

  handleCrewname = (name:string) => {
    this.crewname = name;
  }
  get getCrewname() {
    return this.crewname;
  }

  handleInComingCall = (incoming: boolean) => {
    this.inComingCall = incoming;
  }
  get getInComingCall() {
    return this.inComingCall;
    }

    setPauseDecline(value: boolean) {
      this.pauseDecline = value;
    }

    // Getter for pauseDecline state
  get getPauseDecline() {
    return this.pauseDecline;
  }

  // Optional: A method to reset pauseDecline if necessary
  resetPauseDecline() {
    this.pauseDecline = false;
  }

}